import React from 'react';

import { bemBlock } from '../../modules/bem';
import { Menu, MenuProps } from '../menu/Menu';

import './DropdownMenu.less';

const block = bemBlock('n-DropdownMenu');

export type DropdownMenuProps = MenuProps &
  React.HTMLAttributes<HTMLDivElement> & {
    'data-role'?: string;
    adaptiveWidth?: boolean;
    elementRef?: React.Ref<HTMLDivElement | null>;
  };

/** @deprecated use ActionsMenu from @neptune/shared/venus-ui instead */
export const DropdownMenu: React.FC<DropdownMenuProps> = ({
  className,
  withPadding = 'sm',
  overflow = { vertical: 'auto', horizontal: 'hidden' },
  'data-role': dataRole = 'dropdown-menu',
  adaptiveWidth = false,
  withBorder = true,
  ...passProps
}) => {
  return (
    <Menu
      className={block({ extra: className, modifiers: { adaptiveWidth } })}
      withPadding={withPadding}
      overflow={overflow}
      data-role={dataRole}
      withBorder={withBorder}
      {...passProps}
    />
  );
};
